<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'NewJob'}"
            class="btn btn-primary btn-round">
          + New Job
        </b-link>
      </template>
    </navbar>
    <!--END Navbar-->

    <b-link :to="{name:'JobUsers'}" class="btn btn-info">users</b-link>


    <b-card>
      <div class="table-responsive">
        <b-table-simple v-if="jobs.length > 0">
          <b-thead>
            <b-tr>
              <b-th>name</b-th>
              <b-th>type</b-th>
              <b-th>status</b-th>
              <b-th>email</b-th>
              <b-th>website</b-th>
              <b-th>description</b-th>
              <b-th>date</b-th>
              <b-th></b-th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <b-tr v-for="(item,index) in jobs" :key="index">
              <td>
                {{ item.name }}
              </td>
              <td>
                {{ item.type }}
              </td>
              <td>
                <badge type="warning" v-if="item.status === 'not_accept'">pending</badge>
              </td>
              <td>
                {{ item.email }}
              </td>
              <td>
                {{ item.website }}
              </td>
              <td>
                {{ item.description }}
              </td>
              <td>
                {{ item.date }}
              </td>
              <td>
                <b-link
                    :to="{name:'DetailsJob',params:{'jobid':item.id}}"
                    class="btn btn-info">
                  {{ $t('detailsTitle') }}
                </b-link>
              </td>
            </b-tr>
          </b-tbody>

        </b-table-simple>

      </div>
    </b-card>

  </div>
</template>

<script>
import Http from '../../Services/HttpService/HttpService'
import Navbar from "../Partials/Navbar";
import Notificaion from "../../Services/Notification/Nottification";


export default {
  name: "Index",
  components: {Navbar},
  data() {
    return {
      jobs: []
    }
  },
  methods: {

    getJobRequests() {
      this.$Progress.start();
      Http.get(Http.apiurl() + 'job/index/new/requests')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.jobs = response.data.data;
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    }
  },
  created() {
    this.getJobRequests();
  }
}
</script>

<style scoped>

</style>